import { render, staticRenderFns } from "./SkyEdit.vue?vue&type=template&id=3a63ff4d&scoped=true&"
import script from "./SkyEdit.vue?vue&type=script&lang=js&"
export * from "./SkyEdit.vue?vue&type=script&lang=js&"
import style0 from "./SkyEdit.vue?vue&type=style&index=0&id=3a63ff4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a63ff4d",
  null
  
)

export default component.exports